import { request } from "@/utils/request";
import { request as remoteRequest } from "@/utils/remoteRequest";
import { commDownFile } from "@/utils/downFile";
import settingHelp from "@/config/localSetting";
const config = settingHelp.getConfig();
const { remoteURL } = config;

export function getResumeInfoPage(data) {
  return remoteRequest({
    url: "/resumeInfo/searchResumeInfoForPage",
    method: "post",
    data,
  });
}

export function getResumePage(data) {
  return remoteRequest({
    url: "/resumeInfo/searchViewResumePostSendForPage",
    method: "post",
    data,
  });
}

export function markIsRead(data) {
  return remoteRequest({
    url: "/postSend/savePostSendIsRead",
    method: "post",
    data,
  });
}

export function classify(data) {
  return request({
    url: "/resumeInfo/classify",
    method: "post",
    data,
  });
}

export function getResumeTypeStatisticData(data) {
  return remoteRequest({
    url: "/resumeInfo/searchPostNum",
    method: "post",
    data,
  });
}

//获取权重配置数据
export function getConfigData(data) {
  return remoteRequest({
    url: "/authWeight/get",
    method: "post",
    data,
  });
}

//保存权重配置
export function saveConfigData(data) {
  return remoteRequest({
    url: "/authWeight/save",
    method: "post",
    data,
  });
}

//获取邮箱配置数据
export function getEmailData(data) {
  return remoteRequest({
    url: "/email/findEmailByDeptCode",
    method: "post",
    data,
  });
}

//保存邮箱配置
export function saveEmailData(data) {
  return remoteRequest({
    url: "/email/save",
    method: "post",
    data,
  });
}

//下载前
export function downloadPreCheck(data) {
  return remoteRequest({
    url: "/resume/downloadPreCheck",
    method: "post",
    data,
  });
}

export async function downloadPdf(data) {
  await commDownFile("get", remoteURL + "/resumePDF/makeResumePDF", data);
}

export async function downloadPdfPackage(data) {
  await commDownFile("get", remoteURL + "/resumePDF/getResumePdfZip", data);
}

export async function downloadWord(data) {
  await commDownFile("get", remoteURL + "/resumeWord/makeResumeWord", data);
}

export async function downloadWordPackage(data) {
  await commDownFile("get", remoteURL + "/resumePDF/getResumeWordZip", data);
}

export async function downloadExcel(data) {
  await commDownFile("get", remoteURL + "/resume/downloadExcel", data);
}

export function getsImportExcelRecord(data) {
  return remoteRequest({
    url: "/resumeInfo/searchImportExcelRecord",
    method: "post",
    data,
  });
}
